/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class CountryListResponseModel {

    public countryId: number;
    public name: string;
    public isoCode2: string;
    public isoCode3: string;
    public postcodeRequired: string;
    public isActive : string; 
  
    constructor(countryResponse: any) {
      this.countryId = countryResponse.countryId || '';
      this.name = countryResponse.name || '';
      this.isoCode2 = countryResponse.isoCode2 || '';
      this.isoCode3 = countryResponse.isoCode3 || '';
      this.postcodeRequired = countryResponse.postcodeRequired || '';
      this.isActive = countryResponse.isActive || '';
    }
}